import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/home/home.vue'

import notFound from '@/views/status/notFound.vue'
import serverError from '@/views/status/serverError.vue'
import newsInformation from '@/views/newsInformation/index.vue' //新闻资讯
import informationDetails from '@/views/newsInformation/informationDetails.vue' //新闻资讯详情
import aboutUs from '@/views/aboutUs/index.vue' //关于我们
// 服务
import dataService from '@/views/services/data/index.vue' //数据类服务
import equity from '@/views/services/equity/index.vue' //股权类服务
import businessServices from '@/views/services/businessServices/index.vue' //商情类服务


import valuation from '@/views/stock/valuationProduct.vue' // 估值嵌入式产品
import bp from '@/views/stock/bp/bp.vue' // 估值嵌入式产品
import bpList from '@/views/stock/bp/list.vue'

import {ProfessionalRoutes} from 'professionalvaluation'; // 引入共享的路由
console.log(ProfessionalRoutes)

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}


Vue.use(VueRouter)

const routes = [
	...ProfessionalRoutes,
	{
		path: '/',
		name: 'home',
		meta: {
			title: '安徽亿众',
			name: 'Home',
			setupType: 1
		},
		component: Home
	},
	{
		path: '/notFound',
		name: 'notFound',
		component: notFound,
		meta: {
			title: '404错误'
		}
	}, {
		path: '/serverError',
		name: 'serverError',
		component: serverError,
		meta: {
			title: '500错误'
		}
	},
	{
		path: '/newsInformation',
		name: 'newsInformation',
		component: newsInformation,
		meta: {
			title: '新闻资讯',
			setupType: 5
		}
	},
	{
		path: '/informationDetails',
		name: 'informationDetails',
		component: informationDetails,
		meta: {
			title: '资讯详情',
			setupType: 5
		}
	},
	{
		path: '/aboutUs',
		name: 'aboutUs',
		component: aboutUs,
		meta: {
			title: '我们',
			setupType: 6
		}
	},
	{
		path: '/valuation',
		name: 'valuation',
		component: valuation,
		meta: {
			title: "估值产品",
			setupType: 111
		}
	},
	{
		path: '/bp',
		name: 'bp',
		component: bp,
		meta: {
			title: "商业计划书",
			setupType: 111
		}
	},
	{
		path:'/bpList',
		name: 'bpList',
		component: bpList,
		meta: {
			title: "我的bp",
			setupType: 111
		}
	},
	{
		path:'/equity',
		name: 'equity',
		component: equity,
		meta: {
			title: "股权类服务",
			setupType: 7
		}
	},
	{
		path:'/dataService',
		name: 'dataService',
		component: dataService,
		meta: {
			title: "数据类服务",
			setupType: 7
		}
	},
	{
		path:'/businessServices',
		name: 'businessServices',
		component: businessServices,
		meta: {
			title: "商情类服务",
			setupType: 7
		}
	}
	



]

const router = new VueRouter({
	routes
})

export default router